import React from 'react';

import { Box, PopperPlacement, RoundIcon, Tooltip } from '@bcp-nextgen-dx-component-factory/design-system';
import { Info } from '@bcp-nextgen-dx-component-factory/icons-accolade';

import { useIconTooltipHelper } from './iconTooltip.helper';

interface TooltipProps {
	label: string;
	placement?: PopperPlacement;
}

interface IconRound {
	source?: string;
	fill?: string;
	color?: string;
}

interface IconTooltipProps {
	tooltip: TooltipProps;
	icon?: IconRound;
}

/**
 * Tooltip for an Round Icon.
 *
 * @param tooltip 		Required field. Can be changed label or placement of tooltip. By default position is bottom.
 * @param icon 		Can be changed source, fill or color of icon. By default source is Info, fill is white and color is colorPalette.color_01[100].
 * @returns			Tooltip for an Round Icon.
 */
export const IconTooltip: React.FC<IconTooltipProps> = (props) => {
	const { tooltip, icon } = props;
	const { colorPalette, anchorIconTooltipRef, tooltipIconTooltipRef } = useIconTooltipHelper();

	return (
		<>
			<Tooltip
				placement={tooltip.placement || 'bottom'}
				description={{ text: tooltip.label }}
				closeOnPressOutside={false}
				ref={tooltipIconTooltipRef}
				anchorRef={anchorIconTooltipRef}
			/>
			<Box
				web={{
					mouseEvents: {
						onMouseEnter: () => tooltipIconTooltipRef.current?.show(),
						onMouseLeave: () => tooltipIconTooltipRef.current?.hide(),
					},
				}}
				ref={anchorIconTooltipRef}
			>
				<RoundIcon
					mode="custom"
					icon={{
						source: icon?.source || Info,
						svgProps: { fill: icon?.fill || 'white' },
					}}
					color={icon?.color || colorPalette.color_01[100]}
					size="xxSmall"
				/>
			</Box>
		</>
	);
};
